var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CriterionDetailsDialog", {
        attrs: { viewModel: _vm.criterionDetailsDialog },
      }),
      _vm._v(" "),
      _c("AlternativeDetailsDialog", {
        attrs: { viewModel: _vm.alternativeDetailsDialog },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.initialized === false
            ? _c("h3", { staticClass: "text-center" }, [
                _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                _vm._v(" Loading..."),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.initialized === true
            ? [
                _c(
                  "nav",
                  { staticClass: "navbar fixed-bottom navbar-dark bg-dark" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container d-flex justify-content-center",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "btn-group",
                            attrs: { role: "group" },
                          },
                          [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: `/#/scoring/criterion/${_vm.workspaceId}/${_vm.surveyId}/${_vm.projectUserId}/${_vm.prevCriterionId}`,
                                    expression:
                                      "`/#/scoring/criterion/${workspaceId}/${surveyId}/${projectUserId}/${prevCriterionId}`",
                                  },
                                ],
                                staticClass: "btn btn-secondary",
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-angle-double-left",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v("\n                            Prev "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-lowercase d-none d-sm-inline",
                                  },
                                  [_vm._v("criterion")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-warning",
                                attrs: { type: "button" },
                                on: { click: _vm.scrollTop },
                              },
                              [
                                _vm._v(
                                  "\n                            Back to Top\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: `/#/scoring/criterion/${_vm.workspaceId}/${_vm.surveyId}/${_vm.projectUserId}/${_vm.nextCriterionId}`,
                                    expression:
                                      "`/#/scoring/criterion/${workspaceId}/${surveyId}/${projectUserId}/${nextCriterionId}`",
                                  },
                                ],
                                staticClass: "btn btn-secondary",
                              },
                              [
                                _vm._v("\n                            Next "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-lowercase d-none d-sm-inline",
                                  },
                                  [_vm._v("criterion")]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa fa-angle-double-right",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "nav",
                  {
                    staticClass:
                      "navbar navbar-expand-md navbar-dark bg-dark fixed-top",
                  },
                  [
                    _c("div", { staticClass: "container" }, [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "sanitizedHref",
                              rawName: "v-sanitizedHref",
                              value: `/#/scoring/dashboard/${_vm.workspaceId}/${_vm.surveyId}/${_vm.projectUserId}`,
                              expression:
                                "`/#/scoring/dashboard/${workspaceId}/${surveyId}/${projectUserId}`",
                            },
                          ],
                          staticClass: "btn btn-light mr-auto",
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-angle-double-left",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            "\n                        My Survey\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "progress mx-2 w-50",
                          staticStyle: {
                            height: "38px",
                            "background-color": "#D3D3D3",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "progress-bar",
                              style: { width: _vm.progress + "%" },
                              attrs: { role: "progressbar" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.AnsweredQuestionsCount) +
                                  "/" +
                                  _vm._s(_vm.questionsCount)
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.IsSaved == null
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-warning",
                              attrs: { type: "button" },
                              on: { click: _vm.handleSavePanelistVotesCommand },
                            },
                            [
                              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                              _vm._v(" Saving...\n                    "),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.IsSaved === true
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-light",
                              attrs: { type: "button" },
                              on: { click: _vm.handleSavePanelistVotesCommand },
                            },
                            [
                              _vm._v(
                                "\n                        Saved\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.IsSaved === false
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-warning",
                              attrs: { type: "button" },
                              on: { click: _vm.handleSavePanelistVotesCommand },
                            },
                            [
                              _vm._v(
                                "\n                        Save\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-top": "80px",
                      "padding-bottom": "120px",
                    },
                  },
                  [
                    _c("h3", { staticClass: "mt-4", attrs: { id: "top" } }, [
                      _c("span", { staticClass: "font-weight-light" }, [
                        _vm._v("Evaluate "),
                        _c("span", { staticClass: "text-lowercase" }, [
                          _vm._v(_vm._s(_vm.alternativesLabel)),
                        ]),
                        _vm._v(" in the context of:"),
                      ]),
                      _vm._v(
                        " " + _vm._s(_vm.criterionName) + "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "nav",
                      {
                        staticClass:
                          "navbar navbar-expand-md navbar-light bg-light",
                      },
                      [
                        _c("ul", { staticClass: "navbar-nav" }, [
                          _c("li", { staticClass: "nav-item dropdown" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link dropdown-toggle",
                                attrs: {
                                  id: "navbarDropdown",
                                  role: "button",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                Questions: " +
                                    _vm._s(_vm.QuestionsFilter ?? "All") +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      _vm.QuestionsFilter = null
                                    },
                                  },
                                },
                                [
                                  _vm._v("All "),
                                  _c(
                                    "span",
                                    { staticClass: "badge badge-secondary" },
                                    [_vm._v(_vm._s(_vm.questionsCount))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      _vm.QuestionsFilter = "Answered"
                                    },
                                  },
                                },
                                [
                                  _vm._v("Answered "),
                                  _c(
                                    "span",
                                    { staticClass: "badge badge-secondary" },
                                    [_vm._v(_vm._s(_vm.AnsweredQuestionsCount))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      _vm.QuestionsFilter = "Not answered"
                                    },
                                  },
                                },
                                [
                                  _vm._v("Not answered "),
                                  _c(
                                    "span",
                                    { staticClass: "badge badge-secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.NotAnsweredQuestionsCount)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      _vm.QuestionsFilter = "Commented"
                                    },
                                  },
                                },
                                [
                                  _vm._v("Commented "),
                                  _c(
                                    "span",
                                    { staticClass: "badge badge-secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.CommentedQuestionsCount)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      _vm.QuestionsFilter = "Not commented"
                                    },
                                  },
                                },
                                [
                                  _vm._v("Not commented "),
                                  _c(
                                    "span",
                                    { staticClass: "badge badge-secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.NotCommentedQuestionsCount)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.isPairwise
                            ? _c("li", { staticClass: "nav-item dropdown" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link dropdown-toggle",
                                    attrs: {
                                      role: "button",
                                      "data-toggle": "dropdown",
                                    },
                                    on: { click: _vm.loadConsistencyAnalysis },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Most inconsistent\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "dropdown-menu" },
                                  [
                                    _vm.consistencyAnalysis == null
                                      ? [_vm._m(0)]
                                      : [
                                          _vm.consistencyAnalysis
                                            .InsufficientData === true
                                            ? [
                                                _c(
                                                  "p",
                                                  { staticClass: "px-2" },
                                                  [
                                                    _vm._v(
                                                      "Not enough answers to check consistency"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.consistencyAnalysis
                                            .IsConsistent === true
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click:
                                                        _vm.showConsistencyAnalysisLegend,
                                                    },
                                                  },
                                                  [
                                                    _vm._m(1),
                                                    _vm._v(
                                                      "\n                                            Inconsistency score: " +
                                                        _vm._s(
                                                          _vm
                                                            .consistencyAnalysis
                                                            .CR
                                                        ) +
                                                        "%\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.consistencyAnalysis
                                            .IsAcceptable === true
                                            ? [
                                                _vm._l(
                                                  _vm.MostInconsistent,
                                                  function (q) {
                                                    return _c(
                                                      "a",
                                                      {
                                                        key: q.Id,
                                                        staticClass:
                                                          "dropdown-item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.highlightQuestion(
                                                              q
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(q.Name1) +
                                                            " vs. " +
                                                            _vm._s(q.Name2) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "dropdown-divider",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click:
                                                        _vm.showConsistencyAnalysisLegend,
                                                    },
                                                  },
                                                  [
                                                    _vm._m(2),
                                                    _vm._v(
                                                      "\n                                            Inconsistency score: " +
                                                        _vm._s(
                                                          _vm
                                                            .consistencyAnalysis
                                                            .CR
                                                        ) +
                                                        "%\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.consistencyAnalysis
                                            .IsInconsistent === true
                                            ? [
                                                _vm._l(
                                                  _vm.MostInconsistent,
                                                  function (q) {
                                                    return _c(
                                                      "a",
                                                      {
                                                        key: q.Id,
                                                        staticClass:
                                                          "dropdown-item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.highlightQuestion(
                                                              q
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(q.Name1) +
                                                            " vs. " +
                                                            _vm._s(q.Name2) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "dropdown-divider",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click:
                                                        _vm.showConsistencyAnalysisLegend,
                                                    },
                                                  },
                                                  [
                                                    _vm._m(3),
                                                    _vm._v(
                                                      "\n                                            Inconsistency score: " +
                                                        _vm._s(
                                                          _vm
                                                            .consistencyAnalysis
                                                            .CR
                                                        ) +
                                                        "%\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "form",
                          { staticClass: "form-inline my-2 my-lg-0 ml-auto" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.SearchPhrase,
                                  expression: "SearchPhrase",
                                },
                              ],
                              staticClass: "form-control mr-sm-2",
                              attrs: {
                                type: "search",
                                placeholder: "Filter...",
                              },
                              domProps: { value: _vm.SearchPhrase },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.SearchPhrase = $event.target.value
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.DirectRatesView, function (dr) {
                      return _c("div", { key: dr.Id }, [
                        _c("p", { staticClass: "mt-5 mb-3 lead" }, [
                          _c("strong", [_vm._v(_vm._s(dr.OrderValue) + ".")]),
                          _vm._v(
                            "\n                        How would you rate "
                          ),
                          _c("span", { staticClass: "text-lowercase" }, [
                            _vm._v(_vm._s(_vm.alternativeLabel)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "text-primary",
                              on: {
                                click: function ($event) {
                                  return _vm.ShowAlternativeDetailsCommand(
                                    dr.AlternativeName,
                                    dr.AlternativeDescription
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(dr.AlternativeName))]
                          ),
                          _vm._v(
                            "\n                        in the context of "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "text-dark font-italic",
                              on: { click: _vm.ShowDetailsCommand },
                            },
                            [_vm._v(_vm._s(_vm.criterionName))]
                          ),
                          _vm._v("?\n                    "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-8 col-sm-12" },
                            [
                              _c("PanelistSurveyVoteEditorDr", {
                                attrs: {
                                  propValue: dr.Value,
                                  propComment: dr.Comment,
                                  propScaleLevels: _vm.scaleLevels,
                                },
                                on: {
                                  "update-value": function ($event) {
                                    return _vm.updateValue(dr, $event)
                                  },
                                  "update-comment": function ($event) {
                                    return _vm.updateComment(dr, $event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.PairwiseComparisonsView, function (pc) {
                      return _c("div", { key: pc.Id }, [
                        _c(
                          "div",
                          {
                            staticClass: "row justify-content-start",
                            attrs: { id: pc.DomId },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-md-8 col-sm-12",
                                class: { "bg-warning": pc.Highlighted },
                              },
                              [
                                _c("p", { staticClass: "mt-5 mb-3 lead" }, [
                                  _c("strong", [
                                    _vm._v(_vm._s(pc.OrderValue) + "."),
                                  ]),
                                  _vm._v(
                                    "\n                                In the context of "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-dark font-italic",
                                      on: { click: _vm.ShowDetailsCommand },
                                    },
                                    [_vm._v(_vm._s(_vm.criterionName))]
                                  ),
                                  _vm._v(
                                    ",\n                                which "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "text-lowercase" },
                                    [_vm._v(_vm._s(_vm.alternativeLabel))]
                                  ),
                                  _vm._v(" do you prefer: "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.ShowAlternativeDetailsCommand(
                                            pc.FirstAlternativeName,
                                            pc.FirstAlternativeDescription
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(pc.FirstAlternativeName))]
                                  ),
                                  _vm._v(
                                    " or\n                                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.ShowAlternativeDetailsCommand(
                                            pc.SecondAlternativeName,
                                            pc.SecondAlternativeDescription
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(pc.SecondAlternativeName))]
                                  ),
                                  _vm._v("?\n                            "),
                                ]),
                                _vm._v(" "),
                                _c("PanelistSurveyVoteEditorPc", {
                                  attrs: {
                                    propValue: pc.Value,
                                    propComment: pc.Comment,
                                    propFirstAlternativeName:
                                      pc.FirstAlternativeName,
                                    propSecondAlternativeName:
                                      pc.SecondAlternativeName,
                                  },
                                  on: {
                                    "update-value": function ($event) {
                                      return _vm.updateValue(pc, $event)
                                    },
                                    "update-comment": function ($event) {
                                      return _vm.updateComment(pc, $event)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ])
                    }),
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "m-4" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "fa-stack fa-lg fa-stack-sm" }, [
      _c("i", { staticClass: "fa fa-circle fa-stack-1x text-success" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa-regular fa-face-smile fa-stack-1x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "fa-stack fa-lg fa-stack-sm" }, [
      _c("i", { staticClass: "fa fa-circle fa-stack-1x text-warning" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa-regular fa-face-meh fa-stack-1x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "fa-stack fa-lg fa-stack-sm" }, [
      _c("i", { staticClass: "fa fa-circle fa-stack-1x text-danger" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa-regular fa-face-frown fa-stack-1x" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }